/**
 * Registers the companion's chart tools (chart-tools.ts) on demand, once
 * `aichartdrawing-release` is on for this user, so a user without the flag never
 * registers them or sends them to the companion. Registration is idempotent and
 * lasts until reload. A rollout gate, not a security boundary.
 */
export function loadChartTools(): Promise<void> {
  return import('./chart-tools').then((m) => m.registerChartTools())
}
